<template>
    <div>
        <div class="page-header">
            <img :src="siteInfo.siteLogo">
            <div class="page-header-title">
                <h5 class="site-title">{{siteInfo.siteName}}</h5>
                <p class="site-desc">{{siteInfo.siteDesc}}</p>
            </div>
        </div>
        <div class="home-nav">
            <van-row type="flex" justify="center" class="">
                <van-col span="6">
                    <div @click="$router.push({name:'index'})" class="flex-content">
                        <img src="../assets/images/query.fd2e6f2c.png">
                        <p>查询</p>
                    </div>
                </van-col>
                <van-col span="6">
                    <div @click="$router.push({name:'order'})" class="flex-content">
                        <img src="../assets/images/order.edc98302.png">
                        <p>续费记录</p>
                    </div>
                </van-col>
                <van-col span="6">
                    <div @click="$router.push({name:'bind'})" class="flex-content">
                        <img src="../assets/images/auth.46bece58.png">
                        <p>实名绑定</p>
                    </div>
                </van-col>
                <van-col span="6">
                    <div @click="$router.push({name:'feedback'})" class="flex-content">
                        <img src="../assets/images/feedback.eb8634f3.png">
                        <p>投诉建议</p>
                    </div>
                </van-col>
            </van-row>
        </div>
    </div>
</template>
<script>
    export default {
        name: "App",
        data: () => ({
            token: '',
            siteInfo: {}
        }),
        watch: {},
        created() {
            this.fetchData('/site/info', '', (res) => {
                if (res.code) {
                    this.siteInfo = res.data
                }
            })
        },
        methods: {}
    };




</script>

<style>
    body, html {
        padding: 0;
        margin: 0;
    }

    #app {
        font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        padding: 0;
        margin: 0;
        padding-bottom: .3rem;
    }

    .page-header {
        height: 2.5rem;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        background: -webkit-gradient(linear, left top, left bottom, from(#3c6bff), to(#75b2f9));
        background: linear-gradient(#3c6bff, #75b2f9);
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
        box-shadow: 0 0 0.6rem 0.6rem #75b2f9;
    }

    .page-header img {
        margin: 0 .2rem 0 .5rem;
        background: #fff;
        width: 1rem;
        height: 1rem;
        padding: .1rem;
        border-radius: 2rem;
        border: .05rem solid #75b2f9;
    }

    .page-header .page-header-title {
        color: #fff;
        font-weight: 700;
        text-align: left;
        padding-left: .2rem;
    }

    .page-header .page-header-title .site-title {
        padding: 0;
        margin: 0;
        font-size: .5rem;
        line-height: .5rem;
    }

    .page-header .page-header-title .site-desc {
        margin: .1rem 0;
        padding: 0;
        font-size: .3rem;
    }

    .home-nav {
        width: 6.74rem;
        margin: auto;
        padding-top: .1rem;
        padding-bottom: .1rem;
        background: #fff;
        border-radius: .1rem;
        box-shadow: 0 0 0.02rem #dedede;
    }

    .home-nav img {
        margin: 0;
        width: .8rem;
        height: .8rem;
    }

    .home-nav p {
        margin-top: -.1rem;
        font-size: .22rem;
        color: #555;
    }

    .page-footer {
        bottom: .3rem;
        font-size: .16rem;
        color: #555;
        text-align: center;
        width: 7.5rem;
    }

    .page-footer a {
        color: #666;
        text-decoration: #3a8ee6;
    }

    .warm-tips {
        font-size: .25rem;
        margin: 0 .3rem;
        padding: 0 .3rem;
    }

    .warm-tips h5 {
        text-align: left;
        margin: .2rem 0;
        padding-left: .1rem;
        font-size: .3rem;
        border-left: .2rem solid #75b2f9;
    }

    .warm-tips ol {
        text-align: left;
        padding: 0;
        font-size: .24rem;
    }

    .warm-tips ol li {
        list-style: disc;
        line-height: .4rem;
    }

</style>



// WEBPACK FOOTER //
// src/components/header.vue